// @flow @jsx h
import { h } from 'preact'
import { bem } from '@nrk/dh-utils'
import style from './PartyColumn.css'
import { getWidthAsText } from './lib/getWidthAsText'

import type { PoliticalParty } from './types'

type Props = {
  containerWidth?: number,
  politicalParty: PoliticalParty,
  maxValue: number,
}

function formatPercentage (value: number) {
  return value.toFixed(1).replace('.', ',')
}

function formatChange (value: number) {
  const str = value.toFixed(1).replace('.', ',')
  return value < 0 ? `−${str.substr(1)}` : `+${str}`
}

function getSummary (politicalParty: PoliticalParty) {
  const { name, previousPeriod, currentPeriod } = politicalParty
  const diff = currentPeriod - previousPeriod

  let text
  if (diff === 0) {
    text = 'det samme som ved forrige måling'
  } else {
    text = `${formatPercentage(Math.abs(diff))} prosentpoeng ${diff > 0 ? 'mer' : 'mindre'} enn ved forrige måling`
  }
  return `${name} har ${currentPeriod} % oppslutning – ${text}`
}

export function PartyColumn (props: Props) {
  const { politicalParty, maxValue, containerWidth } = props
  const { nameShort, previousPeriod, currentPeriod } = politicalParty
  const diff = currentPeriod - previousPeriod
  const previousPeriodSizePercent = previousPeriod / maxValue * 100
  const currentPeriodSizePercent = currentPeriod / maxValue * 100
  const widthAsText = getWidthAsText(containerWidth)

  return (
    <div className={bem(style.withComparisonPartyColumn, widthAsText)} aria-label={getSummary(politicalParty)}>
      <div className={bem(style.withComparisonPartyColumn__barContainer, widthAsText)} aria-hidden='true'>
        <div className={bem(style.withComparisonPartyColumn__bar, nameShort, 'previous', widthAsText)} style={{
          width: `${previousPeriodSizePercent}%`,
          height: `${previousPeriodSizePercent}%`
        }} />
        <div className={bem(style.withComparisonPartyColumn__bar, nameShort, widthAsText)} style={{
          width: `${currentPeriodSizePercent}%`,
          height: `${currentPeriodSizePercent}%`
        }}>
          <div className={bem(style.withComparisonPartyColumn__bar__diff, widthAsText)} aria-hidden='true'>{formatChange(diff)}</div>
        </div>
      </div>
      <div className={bem(style.withComparisonPartyColumn__name, widthAsText)}>{nameShort}</div>
      <div className={bem(style.withComparisonPartyColumn__value, widthAsText)}>{formatPercentage(currentPeriod)} %</div>
      <div className={bem(style.withComparisonPartyColumn__diff, widthAsText)}>{formatChange(diff)}</div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/withComparison/PartyColumn.js